import Mutations from '../../odata/mutations';

export default { ...new Mutations('quoteTemplate'), ...new Mutations('quoteTemplates') };
